import landscapeSrc from "./landscape.svg";
import portraitSrc from "./portrait.svg";

const hwzPlaceholders = {
  landscape: {
    src: landscapeSrc,
    srcWidth: 1080,
    srcHeight: 608,
    alt: "",
  },
  portrait: {
    src: portraitSrc,
    srcWidth: 780,
    srcHeight: 1024,
    alt: "",
  },
  square: {
    src: landscapeSrc,
    srcWidth: 315,
    srcHeight: 315,
    alt: "",
  },
  wide: {
    src: landscapeSrc,
    srcWidth: 1000,
    srcHeight: 563,
    alt: "",
  },
};

export default hwzPlaceholders;
